"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constants = require("./constants");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    disableCreditCard: _propTypes.default.bool,
    disableFields: _propTypes.default.bool,
    formRef: _propTypes.default.object,
    translation: _propTypes.default.shape({
      cardNumber: _propTypes.default.string,
      expiryDate: _propTypes.default.string,
      cardholderName: _propTypes.default.string
    }),
    initialValues: _propTypes.default.shape({
      cardNumber: _propTypes.default.string,
      expiryDate: _propTypes.default.string,
      cardholderName: _propTypes.default.string
    }),
    onSubmit: _propTypes.default.func,
    handleField: _propTypes.default.func,
    showDefaultCardToggle: _propTypes.default.bool,
    isToggle: _propTypes.default.bool,
    onErrors: _propTypes.default.func,
    isPaymentPage: _propTypes.default.bool,
    showPaymentCheckbox: _propTypes.default.bool,
    maskedCVV: _propTypes.default.bool,
    showCardAcceptedMessage: _propTypes.default.bool,
    processingFee: _propTypes.default.shape({
      amount: _propTypes.default.number,
      currency: _propTypes.default.string
    }),
    askConfirmationForMakingDefaultCard: _propTypes.default.bool,
    resetDefaultCardOnCancelSave: _propTypes.default.bool,
    showDefaultCardInfoTooltip: _propTypes.default.bool,
    isFetchingProcessingFee: _propTypes.default.bool
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    disableCreditCard: false,
    disableFields: false,
    customProperties: {},
    translation: _constants.TRANSLATION,
    onSubmit: function onSubmit() {},
    handleField: function handleField() {},
    initialValues: _constants.INITIAL_VALUES,
    showDefaultCardToggle: true,
    isToggle: true,
    isPaymentPage: false,
    showPaymentCheckbox: true,
    maskedCVV: true,
    showCardAcceptedMessage: false,
    askConfirmationForMakingDefaultCard: false,
    resetDefaultCardOnCancelSave: false,
    showDefaultCardInfoTooltip: false,
    isFetchingProcessingFee: false
  }
};
exports.default = _default;